import i18n from '@/plugins/i18n';

/* eslint-disable import/prefer-default-export */
export const FAVOURITE_HEADER = [
  {
    text: i18n.t('components.favourites.table.name'),
    align: 'left',
    sortable: false,
    value: 'alias',
    class: 'text-uppercase',
  },
  {
    text: i18n.t('components.favourites.table.address'),
    align: 'left',
    sortable: false,
    value: 'fullAddressText',
    class: 'text-uppercase',
  },
  {
    text: i18n.t('components.favourites.table.favourite_pickup'),
    align: 'left',
    sortable: false,
    value: 'suggestForPickupAddress',
    class: 'text-uppercase',
  },
  {
    text: i18n.t('components.favourites.table.favourite_dropoff'),
    align: 'left',
    sortable: false,
    value: 'suggestForDestinationAddress',
    class: 'text-uppercase',
  },
  {
    align: 'right',
    sortable: false,
    value: 'actions',
    class: 'text-uppercase',
  },
];

export const BUSINESS_PASSANGER_HEADER = [
  {
    text: i18n.t('components.employeeList.list.createdAt'),
    align: 'left',
    sortable: true,
    value: 'createdAt',
    class: 'text-uppercase',
  },
  {
    text: i18n.t('components.employeeList.list.name'),
    align: 'left',
    sortable: false,
    value: 'givenName',
    class: 'text-uppercase',
  },
  {
    text: i18n.t('components.employeeList.list.email'),
    align: 'left',
    sortable: false,
    value: 'email',
    class: 'text-uppercase',
  },
  {
    text: i18n.t('components.employeeList.list.group'),
    align: 'left',
    sortable: false,
    value: 'group',
    class: 'text-uppercase',
  },
  {
    text: i18n.t('components.employeeList.list.phone'),
    align: 'left',
    sortable: false,
    value: 'passenger.phoneNumber',
    class: 'text-uppercase',
  },
  {
    value: 'actions',
    sortable: false,
    align: 'end',
  },
];

export const BUSINESS_GUEST_HEADER = [
  {
    text: i18n.t('components.employeeList.list.createdAt'),
    align: 'left',
    sortable: true,
    value: 'createdAt',
    class: 'text-uppercase',
  },
  {
    text: i18n.t('components.employeeList.list.name'),
    align: 'left',
    sortable: false,
    value: 'givenName',
    class: 'text-uppercase',
  },
  {
    text: i18n.t('components.employeeList.list.phone'),
    align: 'left',
    sortable: false,
    value: 'phoneNumber',
    class: 'text-uppercase',
  },
  {
    value: 'actions',
    sortable: false,
    align: 'end',
  },
];
